var map = {
	"./a-a-a-de-winter-de-isch-da.pdf": 50,
	"./alli-mini-aentli.pdf": 51,
	"./alte-birebaum.pdf": 52,
	"./chom-mier-wei-go-chrieseli-guenne.pdf": 53,
	"./det-aene-am-baergli.pdf": 54,
	"./es-buurebueebli.pdf": 55,
	"./ich-ghoere-es-gloeggli.pdf": 56,
	"./ihr-klare-seraphim.pdf": 57,
	"./liederland-swissmom-special.pdf": 58,
	"./meiteli-wenn-due-witt-go-tanzae.pdf": 59,
	"./mini-farb-und-dini.pdf": 60,
	"./oh-du-goldigs-suenneli.pdf": 61,
	"./roti-roesli-im-garte.pdf": 62,
	"./s-isch-mer-alles-ei-ding.pdf": 63,
	"./s-ramseiers-wei-go-grase.pdf": 64,
	"./siebe-chugelrundi-saeu.pdf": 65,
	"./tierlitaenzli-chatzeschwaenzli.pdf": 66,
	"./wenn-eine-tannigi-hose-haet.pdf": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49;